export default __webpack_public_path__ + "a66bf8df1f5b833e31d0b6b287f51312.svg";